// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'frontend_core/dist/styles/colors'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'

import { useAppLink } from 'hooks/useAppLink'
import { amplitudeLogEvent } from 'helpers/amplitude'

const Wrapper = styled.div`
  display: block;
  text-align: center;
`

const Text = styled.p`
  font-weight: 600;
  font-size: ${fontSize.medium}px;
  line-height: 135%;
  text-align: center;
  color: ${Colors.mono.gray100};
  margin-bottom: ${spacing.medium}px;
`

const Button = styled.a`
  display: block;
  height: ${spacing.large_2}px;
  border-radius: 40px;
  border: 1px solid ${Colors.mono.gray100};
  background: ${Colors.mono.white};
  color: ${Colors.mono.gray100};
  padding: ${spacing.medium}px;
  margin: 0 23.75px;
  text-align: center;
  text-decoration: none;
  font-weight: 600;
  font-size: ${fontSize.medium}px;
  line-height: 1;
  box-sizing: border-box;
`
const AppLinkSection = () => {
  const { appLinkHref, handleAppLinkClick } = useAppLink()

  const handleClick = e => {
    amplitudeLogEvent('Select App Install Button on Login')
    handleAppLinkClick(e)
  }

  return (
    <Wrapper>
      <Text>アプリならログインの手間いらず</Text>
      <Button href={appLinkHref} onClick={handleClick}>
        アプリで開く
      </Button>
    </Wrapper>
  )
}
export default AppLinkSection
